import React from 'react';
import DynamicTable, { type DynamicTableProps } from '@atlaskit/dynamic-table';
import ArrowRight from '@atlaskit/icon/glyph/arrow-right';
import Lozenge from '@atlaskit/lozenge';
import { Box, Flex, Text } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages';
import { getStatus } from './utils';

export const StatusTable = () => {
	const { formatMessage } = useIntl();
	const Status = getStatus(formatMessage);

	const rows: DynamicTableProps['rows'] = Object.values(Status).map((status, index) => ({
		key: `row-${index}`,
		cells: [
			{
				key: `cell-${index}-status-in-Opsgenie`,
				content: (
					<Box paddingInlineStart="space.100" paddingBlock="space.150">
						<Text as="p">{status.ogStatus}</Text>
					</Box>
				),
			},
			{
				key: `cell-${index}-status-in-Jira`,
				content: (
					<Box paddingInlineStart="space.100" paddingBlock="space.150">
						<Flex alignItems="center" justifyContent="space-between">
							<Text as="p">{status.jiraStatus}</Text>
							<Flex columnGap="space.025">
								<ArrowRight label="" size="small" />
								<Lozenge appearance={status.appearance}>{status.lozengeContent}</Lozenge>
							</Flex>
						</Flex>
					</Box>
				),
			},
		],
	}));

	const head = {
		cells: [
			{
				key: 'priority-in-Opsgenie',
				content: (
					<Box paddingInlineStart="space.100">
						{formatMessage(messages.statusInOpsgenieNonFinal)}
					</Box>
				),
			},
			{
				key: 'priority-in-Jira',
				content: (
					<Box paddingInlineStart="space.100">{formatMessage(messages.statusInJiraNonFinal)}</Box>
				),
			},
		],
	};

	return <DynamicTable head={head} rows={rows} isFixedSize />;
};
